/* FRAGS · Collection + Features — Animaciones y partículas (sin imports) */
(function(){
  const revealCards = () => {
    if (typeof gsap === 'undefined') return;
    if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);
    document.querySelectorAll('.reveal-card').forEach((card, index) => {
      gsap.fromTo(card,
        { opacity: 0, y: 60, scale: 0.95 },
        { opacity: 1, y: 0, scale: 1, duration: 0.8, delay: index * 0.2, ease: 'power3.out',
          scrollTrigger: { trigger: card, start: 'top 80%', toggleActions: 'play none none reverse' } });
    });
  };

  const revealFeatures = () => {
    if (typeof gsap === 'undefined') return;
    document.querySelectorAll('.reveal-feature').forEach((feature, index) => {
      gsap.fromTo(feature,
        { opacity: 0, y: 40 },
        { opacity: 1, y: 0, duration: 0.7, delay: index * 0.15, ease: 'power2.out',
          scrollTrigger: { trigger: feature, start: 'top 85%', toggleActions: 'play none none reverse' } });
    });
  };

  const initParticles = async () => {
    if (typeof tsParticles === 'undefined') return;
    const el = document.getElementById('particles');
    if (!el) return;
    try{
      await tsParticles.load({
        id: 'particles',
        options: {
          detectRetina: true, background: { color: { value: 'transparent' } },
          particles: {
            number: { value: 80, density: { enable: true, area: 800 } },
            color: { value: ['#c9a227', '#e8d4a0', '#ffffff'] },
            shape: { type: 'circle' },
            opacity: { value: { min: 0.1, max: 0.5 }, animation: { enable: true, speed: 0.5, minimumValue: 0.1 } },
            size:    { value: { min: 1, max: 3 }, animation: { enable: true, speed: 2, minimumValue: 0.5 } },
            move:    { enable: true, speed: 0.5, direction: 'none', outModes: { default: 'out' }, random: true },
            links:   { enable: false }
          },
          interactivity: { detectsOn: 'window', events: { onHover: { enable: false }, onClick: { enable: false }, resize: true } },
          fullScreen: { enable: false }
        }
      });
    }catch(e){}
  };

  revealCards();
  revealFeatures();
  initParticles();

  // Smooth scroll (por si usas #collection / #features)
  document.querySelectorAll('a[href^="#"]').forEach(a=>{
    a.addEventListener('click', e=>{
      const href = a.getAttribute('href'); if(!href || href==='#') return;
      const t = document.querySelector(href); if(!t) return;
      e.preventDefault(); t.scrollIntoView({ behavior:'smooth', block:'start' });
    });
  });
})();
